import {
  INIT_REDUCER,
  CLEAR_ERRORS,
  CREATE_ERRORS,
  GET_DELIVERY_NOTES_REQUEST,
  GET_DELIVERY_NOTE_REQUEST,
  UPDATE_DELIVERY_NOTE_REQUEST, // <-- importa el tipo
} from './types';

const getDeliveryNotes = (payload) => ({
  type: GET_DELIVERY_NOTES_REQUEST,
  payload,
});

const getDeliveryNote = (payload) => ({
  type: GET_DELIVERY_NOTE_REQUEST,
  payload,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

const updateDeliveryNote = (payload) => ({
  type: UPDATE_DELIVERY_NOTE_REQUEST,
  payload,
});

export {
  getDeliveryNotes,
  initReducer,
  clearErrors,
  createErrors,
  getDeliveryNote,
  updateDeliveryNote,
};
